<template>
  <el-dialog
    title="收房付款计划"
    :visible.sync="dialogVisible"
    width="88%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="plan-dialog"
    top="3vh"
  >
    <div class="plan-dialog-content">
      <!-- ====== 第一部分：房源信息 ====== -->
<div class="section-part part-one">
  <el-form :model="planForm" size="small">
    <el-row :gutter="20">
      <!-- 第一行：是否生成过出房付款计划 -->
      <el-col :span="24">
        <div class="status-row">
          <span class="status-label">是否生成过出房付款计划：</span>
          <el-tag
            :type="hasPlan ? 'success' : 'danger'"
            size="medium"
            effect="dark"
          >
            {{ hasPlan ? '是' : '否' }}
          </el-tag>
        </div>
      </el-col>

      <!-- 第二行：合同起始日 + 合同到期日 -->
      <el-col :span="12">
        <el-form-item label="合同起始日" label-width="100px" prop="合同起始日">
          <el-date-picker
            v-model="planForm.合同起始日"
            type="date"
            placeholder="请选择合同起始日"
            value-format="timestamp"
            style="width:100%"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="合同到期日" label-width="100px" prop="合同到期日">
          <el-date-picker
            v-model="planForm.合同到期日"
            type="date"
            placeholder="请选择合同到期日"
            value-format="timestamp"
            style="width:100%"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>

      <!-- 第三行：第一年免租期（天）+ 收房租金（元/月）+ 支付周期 -->
      <el-col :span="8">
        <el-form-item label="第一年免租期（天）" label-width="130px" prop="第一年免租期">
          <el-input-number
            v-model="planForm.第一年免租期"
            :min="0"
            :step="1"
            placeholder="请输入免租期"
            style="width:100%"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="收房租金（元/月）" label-width="130px" prop="收房租金">
          <el-input-number
            v-model="planForm.收房租金"
            :min="0"
            :precision="2"
            :step="100"
            placeholder="请输入租金"
            style="width:100%"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="支付周期" label-width="100px" prop="支付周期">
          <el-select
            v-model="planForm.支付周期"
            placeholder="请选择支付周期"
            style="width:100%"
            :disabled="hasPlan"
          >
            <el-option label="按季" value="按季" />
            <el-option label="按年" value="按年" />
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 第四行（新增）：银行卡号 + 支付户名 + 开户行 -->
      <el-col :span="8">
        <el-form-item label="银行卡号" label-width="100px" prop="银行卡号">
          <el-input
            v-model="planForm.银行卡号"
            placeholder="请输入银行卡号"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="支付户名" label-width="100px" prop="支付户名">
          <el-input
            v-model="planForm.支付户名"
            placeholder="请输入支付户名"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="开户行" label-width="100px" prop="开户行">
          <el-input
            v-model="planForm.开户行"
            placeholder="请输入开户行"
            :disabled="hasPlan"
          />
        </el-form-item>
      </el-col>

      <!-- 第五行：按钮（右对齐） -->
      <el-col :span="24">
        <div class="button-row">
          <el-button
            type="primary"
            :disabled="hasPlan"
            @click="handleGenerate"
            :loading="generating"
          >
            生成
          </el-button>
          <el-button
            type="warning"
            :disabled="!canRegenerate"
            @click="handleRegenerate"
          >
            重新生成
          </el-button>
          <el-button
            type="success"
            plain
            @click="handleReload"
            :loading="reloading"
          >
            重新加载
          </el-button>
        </div>
      </el-col>
    </el-row>
  </el-form>
</div>

      <!-- ====== 第二部分：生成的临时付款计划（可编辑） ====== -->
      <div v-if="showPartTwo" class="section-part part-two">
        <div class="section-title">生成的付款计划（请核对并修改）</div>
        <div class="temp-table-wrapper">
          <el-table :data="tempPlanList" border stripe size="small">
            <el-table-column label="第几次付款" width="120" align="center">
              <template slot-scope="{ row, $index }">
                <el-input-number
                  v-model="row.第几次付款"
                  :min="1"
                  :step="1"
                  size="small"
                  controls-position="right"
                  style="width:100px"
                />
              </template>
            </el-table-column>
            <el-table-column label="付款日期" width="180" align="center">
              <template slot-scope="{ row }">
                <el-date-picker
                  v-model="row.付款日期"
                  type="date"
                  placeholder="请选择日期"
                  value-format="timestamp"
                  size="small"
                  style="width:160px"
                />
              </template>
            </el-table-column>
            <el-table-column label="付款金额" width="150" align="center">
              <template slot-scope="{ row }">
                <el-input-number
                  v-model="row.付款金额"
                  :min="0"
                  :precision="2"
                  :step="100"
                  size="small"
                  controls-position="right"
                  style="width:130px"
                />
              </template>
            </el-table-column>
            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="{ row }">
                <el-tag type="danger" size="small">待付</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="200">
              <template slot-scope="{ row }">
                <el-input v-model="row.备注" size="small" placeholder="请输入备注" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="temp-save-row">
          <el-button
            type="primary"
            @click="handleSaveTempPlan"
            :loading="saving"
            :disabled="tempPlanList.length === 0"
          >
            保存
          </el-button>
        </div>
      </div>

      <!-- ====== 第三部分：已保存的付款计划表格 ====== -->
      <div v-if="showPartThree" class="section-part part-three">
        <div class="section-header">
          <span class="section-title">已生成的付款计划</span>
          <div class="section-actions">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">
              新增
            </el-button>
          </div>
        </div>
        <el-table
          :data="savedPlanList"
          border
          stripe
          v-loading="tableLoading"
          size="small"
          :default-sort="{ prop: '第几次付款', order: 'ascending' }"
        >
          <el-table-column prop="第几次付款" label="第几次付款" width="120" align="center" sortable />
          <el-table-column prop="付款日期" label="付款日期" width="180" align="center">
            <template slot-scope="{ row }">
              {{ formatTimestamp(row.付款日期) }}
            </template>
          </el-table-column>
          <el-table-column prop="付款金额" label="付款金额" width="150" align="right">
            <template slot-scope="{ row }">
              ¥{{ (row.付款金额 || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="状态" label="状态" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag :type="getStatusType(row.状态)" size="small">
                {{ row.状态 || '-' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="备注" label="备注" min-width="200" show-overflow-tooltip />
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="mini"
                @click="openEditDialog(row)"
                :disabled="!canModify(row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="color: #f56c6c;"
                @click="handleDelete(row)"
                :disabled="!canModify(row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="savedPlanList.length === 0" class="empty-tip">
          暂无付款计划数据
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>

    <!-- ====== 新增弹窗 ====== -->
    <el-dialog
      title="新增付款计划"
      :visible.sync="addDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetAddForm"
    >
      <el-form :model="addForm" label-width="120px" size="small">
        <el-form-item label="房屋地址">
          <el-input v-model="addForm.房屋地址" disabled />
        </el-form-item>
        <el-form-item label="第几次付款" required>
          <el-input-number
            v-model="addForm.第几次付款"
            :min="1"
            :step="1"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="付款日期" required>
          <el-date-picker
            v-model="addForm.付款日期"
            type="date"
            placeholder="请选择付款日期"
            value-format="timestamp"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="付款金额" required>
          <el-input-number
            v-model="addForm.付款金额"
            :min="0"
            :precision="2"
            :step="100"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.备注" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleAddSubmit" :loading="addDialog.submitting">
          确认
        </el-button>
      </span>
    </el-dialog>

    <!-- ====== 修改弹窗 ====== -->
    <el-dialog
      title="修改付款计划"
      :visible.sync="editDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetEditForm"
    >
      <el-form :model="editForm" label-width="120px" size="small">
        <el-form-item label="第几次付款" required>
          <el-input-number
            v-model="editForm.第几次付款"
            :min="1"
            :step="1"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="付款日期" required>
          <el-date-picker
            v-model="editForm.付款日期"
            type="date"
            placeholder="请选择付款日期"
            value-format="timestamp"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="付款金额" required>
          <el-input-number
            v-model="editForm.付款金额"
            :min="0"
            :precision="2"
            :step="100"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.备注" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleEditSubmit" :loading="editDialog.submitting">
          确认
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'
import { sfPlanApi } from '@/api/付款/sfPlanApi'
export default {
  name: 'SfPlan',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      generating: false,
      saving: false,
      reloading: false,
      tableLoading: false,

      // ====== 计划表单 ======
      planForm: {
        合同起始日: null,
        合同到期日: null,
        第一年免租期: 0,
        收房租金: null,
        支付周期: '按季',
        银行卡号: '',      // 新增
        支付户名: '',      // 新增
        开户行: ''         // 新增
      },

      // ====== 状态 ======
      hasPlan: false,
      canRegenerate: false,

      // ====== 第二部分：临时数据 ======
      tempPlanList: [],
      showPartTwo: false,

      // ====== 第三部分：已保存数据 ======
      savedPlanList: [],
      showPartThree: false,

      // ====== 新增弹窗 ======
      addDialog: {
        visible: false,
        submitting: false
      },
      addForm: {
        房屋地址: '',
        第几次付款: null,
        付款日期: null,
        付款金额: null,
        备注: ''
      },

      // ====== 修改弹窗 ======
      editDialog: {
        visible: false,
        submitting: false,
        editId: null
      },
      editForm: {
        第几次付款: null,
        付款日期: null,
        付款金额: null,
        备注: ''
      },

      // ====== 房源基础数据（用于填充） ======
      houseData: {}
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },

  methods: {
    // ====== 初始化数据 ======
    initData() {
      const data = this.rowData
      if (!data) return

      this.houseData = { ...data }

      // 填充表单
      this.planForm = {
        合同起始日: this.toMilliseconds(data.合同起始日),
        合同到期日: this.toMilliseconds(data.合同到期日),
        第一年免租期: data['第一年免租期（天）'] || 0,
        收房租金: data['收房租金（元/月）'] || null,
        支付周期: data.支付周期 || '按季',
        银行卡号: data.银行卡号 || '',      // 新增
        支付户名: data.支付户名 || '',      // 新增
        开户行: data.开户行 || ''          // 新增
      }

      // 重置状态
      this.tempPlanList = []
      this.savedPlanList = []
      this.showPartTwo = false
      this.showPartThree = false

      // 加载数据
      this.handleReload()
    },

    // ====== 重新加载 ======
    handleReload() {
      this.reloading = true
      this.checkPlan()
    },

    // ====== 检查是否生成过计划 ======
    async checkPlan() {
      if (!this.houseData.id) {
        this.reloading = false
        return
      }

      try {
        const params = {
          房源ID: String(this.houseData.id),
          合同起始日: this.planForm.合同起始日,
          合同到期日: this.planForm.合同到期日
        }

        console.log('检查计划参数===', params)

        const res = await sfPlanApi.check(params)
        console.log('检查计划返回===', res)

        if (res.code === 200) {
          const { hasPlan, list } = res.data || {}
          this.hasPlan = hasPlan || false

          if (hasPlan && list && list.length > 0) {
            this.savedPlanList = list.map(item => this.mapFields(item))
            this.showPartThree = true
            this.showPartTwo = false

            const allPending = this.savedPlanList.every(item => item.状态 === '待付')
            this.canRegenerate = allPending
          } else {
            this.savedPlanList = []
            this.showPartThree = false
            this.showPartTwo = true
            this.canRegenerate = false
          }
        } else {
          this.$message.error(res.message || '检查计划失败')
        }
      } catch (error) {
        console.error('检查计划失败:', error)
        this.$message.error(error.message || '检查计划失败，请稍后重试')
      } finally {
        this.reloading = false
      }
    },

    // ====== 字段映射（后端 -> 前端） ======
    mapFields(data) {
      const map = {
        'id': 'id',
        '房源ID': '房源ID',
        '状态': '状态',
        '付款日期': '付款日期',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '银行卡号': '银行卡号',
        '备注': '备注',
        '房东': '房东',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '开户行': '开户行',
        '支付户名': '支付户名'
      }

      const result = {}
      for (const [key, val] of Object.entries(map)) {
        if (data[key] !== undefined && data[key] !== null) {
          result[val] = data[key]
        }
      }
      // ====== 时间戳字段转为毫秒级（用于前端显示） ======
      const timestampFields = ['付款日期', '合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null) {
          result[field] = this.toMilliseconds(result[field])
        }
      })
      return result
    },

    // ====== 字段映射（前端 -> 后端） ======
    mapToBackend(data) {
      const map = {
        '房源ID': '房源ID',
        '状态': '状态',
        '付款日期': '付款日期',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '银行卡号': '银行卡号',
        '备注': '备注',
        '房东': '房东',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '开户行': '开户行',
        '支付户名': '支付户名'
      }

      const result = {}
      for (const [key, val] of Object.entries(map)) {
        if (data[key] !== undefined && data[key] !== null) {
          result[val] = data[key]
        }
      }
      const timestampFields = ['付款日期', '合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null) {
          result[field] = this.toSeconds(result[field])
        }
      })
      return result
    },

    // ====== 生成付款计划 ======
    handleGenerate() {
      const form = this.planForm

      // 验证必填字段
      if (!form.合同起始日) {
        this.$message.warning('请选择合同起始日')
        return
      }
      if (!form.合同到期日) {
        this.$message.warning('请选择合同到期日')
        return
      }
      if (form.第一年免租期 === undefined || form.第一年免租期 === null) {
        this.$message.warning('请输入第一年免租期')
        return
      }
      if (!form.收房租金 || form.收房租金 <= 0) {
        this.$message.warning('请输入有效的收房租金')
        return
      }
      if (!form.支付周期) {
        this.$message.warning('请选择支付周期')
        return
      }
      // 新增必填验证
      if (!form.银行卡号 || form.银行卡号.trim() === '') {
        this.$message.warning('请输入银行卡号')
        return
      }
      if (!form.支付户名 || form.支付户名.trim() === '') {
        this.$message.warning('请输入支付户名')
        return
      }
      if (!form.开户行 || form.开户行.trim() === '') {
        this.$message.warning('请输入开户行')
        return
      }

      this.generating = true

      try {
        // 计算付款计划
        const planList = this.calculatePlan(form)
        this.tempPlanList = planList
        this.showPartTwo = true
        this.showPartThree = false

        this.$message.success(`成功生成 ${planList.length} 条付款计划`)
      } catch (error) {
        console.error('生成失败:', error)
        this.$message.error(error.message || '生成失败')
      } finally {
        this.generating = false
      }
    },

    // ====== 计算付款计划算法 ======
    calculatePlan(form) {
      const { 合同起始日, 合同到期日, 第一年免租期, 收房租金, 支付周期 } = form

      // 计算支付周期月数
      let periodMonths = 3 // 默认按季
      if (支付周期 === '按年') {
        periodMonths = 12
      }

      // 付款金额 = 收房租金 × 支付周期月数
      const paymentAmount = 收房租金 * periodMonths

      // 计算第一笔付款日期（合同起始日）
      const startDate = new Date(合同起始日)

      // 计算第一年免租期延后的月数（模糊月数）
      const freeMonths = Math.floor(第一年免租期 / 30)

      // 生成所有付款计划
      const planList = []
      let currentDate = new Date(startDate)
      let count = 1

      // 第一笔付款
      planList.push({
        第几次付款: count,
        付款日期: new Date(currentDate).getTime(),
        付款金额: paymentAmount,
        状态: '待付',
        备注: ''
      })

      // 第二笔及之后的付款
      // 第二笔 = 第一笔 + 免租期延后月数 + 支付周期月数
      let nextDate = new Date(startDate)
      // 延后免租期月数
      nextDate.setMonth(nextDate.getMonth() + freeMonths)
      // 再延后支付周期月数
      nextDate.setMonth(nextDate.getMonth() + periodMonths)

      count = 2

      const endDate = new Date(合同到期日)

      while (nextDate <= endDate) {
        planList.push({
          第几次付款: count,
          付款日期: new Date(nextDate).getTime(),
          付款金额: paymentAmount,
          状态: '待付',
          备注: ''
        })

        // 下一次付款日期 = 当前 + 支付周期月数
        nextDate.setMonth(nextDate.getMonth() + periodMonths)
        count++
      }

      return planList
    },

    // ====== 保存临时计划（批量插入） ======
    async handleSaveTempPlan() {
      if (this.tempPlanList.length === 0) {
        this.$message.warning('没有可保存的数据')
        return
      }

      // 验证必填字段
      for (let i = 0; i < this.tempPlanList.length; i++) {
        const item = this.tempPlanList[i]
        if (!item.付款日期) {
          this.$message.warning(`第 ${i + 1} 条记录缺少付款日期`)
          return
        }
        if (!item.付款金额 || item.付款金额 <= 0) {
          this.$message.warning(`第 ${i + 1} 条记录付款金额无效`)
          return
        }
      }

      // 二次确认
      try {
        await this.$confirm(
          `确认保存 ${this.tempPlanList.length} 条付款计划吗？`,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认保存',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      this.saving = true

      try {
        // 构建批量插入数据
        const dataList = this.tempPlanList.map(item => {
          return {
            房源ID: String(this.houseData.id),
            状态: '待付',
            付款日期: item.付款日期,
            付款金额: Math.round(item.付款金额 * 100) / 100,
            房屋地址: this.houseData.房屋地址 || '',
            第几次付款: item.第几次付款,
            银行卡号: this.planForm.银行卡号 || '',
            备注: item.备注 || '',
            房东: this.houseData.房东姓名 || '',
            合同起始日: this.planForm.合同起始日 ? Math.floor(this.planForm.合同起始日 / 1000) : null,
            合同到期日: this.planForm.合同到期日 ? Math.floor(this.planForm.合同到期日 / 1000) : null,
            开户行: this.planForm.开户行 || '',
            支付户名: this.planForm.支付户名 || ''
          }
        })

        const params = { dataList }
        console.log('批量插入参数===', params)

        const res = await sfPlanApi.insertBatch(params)
        console.log('批量插入返回===', res)

        if (res.code === 200) {
          this.$message.success(`成功保存 ${dataList.length} 条付款计划`)
          this.tempPlanList = []
          this.showPartTwo = false
          // 重新加载数据
          await this.loadSavedPlan()
        } else {
          // 修改：显示后台返回的报错信息
          const errorMsg = res.message || '保存失败'
          this.$message.error(errorMsg)
        }
      } catch (error) {
        console.error('保存失败:', error)
        // 修改：显示捕获到的错误信息
        const errorMsg = error.message || '保存失败，请稍后重试'
        this.$message.error(errorMsg)
      } finally {
        this.saving = false
      }
    },

    // ====== 重新生成 ======
    async handleRegenerate() {
      // 检查是否可以重新生成
      if (this.savedPlanList.some(item => item.状态 !== '待付')) {
        this.$message.warning('已经出现非待付记录，不可重新生成，请手动修改计划')
        return
      }

      try {
        await this.$confirm(
          '请注意，重新生成会清空之前的收房付款计划，点击确认后不可撤回！',
          '重新生成提示',
          {
            type: 'warning',
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            customClass: 'regenerate-confirm'
          }
        )
      } catch {
        return
      }

      try {
        const params = { 房源ID: String(this.houseData.id) }
        console.log('批量作废参数===', params)

        const res = await sfPlanApi.invalidate(params)
        console.log('批量作废返回===', res)

        if (res.code === 200) {
          this.$message.success(res.data?.message || '作废成功')
          // 重置状态
          this.hasPlan = false
          this.canRegenerate = false
          this.savedPlanList = []
          this.showPartThree = false
          this.showPartTwo = true
          this.tempPlanList = []
          // 重新加载
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '作废失败')
        }
      } catch (error) {
        console.error('作废失败:', error)
        this.$message.error(error.message || '作废失败，请稍后重试')
      }
    },

    // ====== 打开新增弹窗 ======
    openAddDialog() {
      this.addForm = {
        房屋地址: this.houseData.房屋地址 || '',
        第几次付款: null,
        付款日期: null,
        付款金额: null,
        备注: ''
      }
      this.addDialog.visible = true
    },

    // ====== 重置新增表单 ======
    resetAddForm() {
      this.addDialog.submitting = false
    },

    // ====== 新增提交 ======
    async handleAddSubmit() {
      const form = this.addForm

      if (!form.第几次付款 || form.第几次付款 < 1) {
        this.$message.warning('请输入有效的第几次付款')
        return
      }
      if (!form.付款日期) {
        this.$message.warning('请选择付款日期')
        return
      }
      if (!form.付款金额 || form.付款金额 <= 0) {
        this.$message.warning('请输入有效的付款金额')
        return
      }

      this.addDialog.submitting = true

      try {
        const params = {
          房源ID: String(this.houseData.id),
          状态: '待付',
          付款日期: form.付款日期,
          付款金额: Math.round(form.付款金额 * 100) / 100,
          房屋地址: this.houseData.房屋地址 || '',
          第几次付款: form.第几次付款,
          银行卡号: this.planForm.银行卡号 || '',
          备注: form.备注 || '',
          房东: this.houseData.房东姓名 || '',
          合同起始日: this.planForm.合同起始日 ? Math.floor(this.planForm.合同起始日 / 1000) : null,
          合同到期日: this.planForm.合同到期日 ? Math.floor(this.planForm.合同到期日 / 1000) : null,
          开户行: this.planForm.开户行 || '',
          支付户名: this.planForm.支付户名 || ''
        }

        console.log('新增参数===', params)

        const res = await sfPlanApi.insert(params)
        console.log('新增返回===', res)

        if (res.code === 200) {
          this.$message.success('新增成功')
          this.addDialog.visible = false
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '新增失败')
        }
      } catch (error) {
        console.error('新增失败:', error)
        this.$message.error(error.message || '新增失败，请稍后重试')
      } finally {
        this.addDialog.submitting = false
      }
    },

    // ====== 判断是否可以修改 ======
    canModify(row) {
      if (!row) return false
      const status = row.状态
      return status === '待付' || status === '部分付款'
    },

    // ====== 打开修改弹窗 ======
    openEditDialog(row) {
      if (!this.canModify(row)) {
        this.$message.warning('该记录状态不可修改')
        return
      }

      this.editDialog.editId = row.id
      this.editForm = {
        第几次付款: row.第几次付款,
        付款日期: row.付款日期,
        付款金额: row.付款金额,
        备注: row.备注 || ''
      }
      this.editDialog.visible = true
    },

    // ====== 重置修改表单 ======
    resetEditForm() {
      this.editDialog.submitting = false
      this.editDialog.editId = null
    },

    // ====== 修改提交 ======
    async handleEditSubmit() {
      const form = this.editForm

      if (!form.第几次付款 || form.第几次付款 < 1) {
        this.$message.warning('请输入有效的第几次付款')
        return
      }
      if (!form.付款日期) {
        this.$message.warning('请选择付款日期')
        return
      }
      if (!form.付款金额 || form.付款金额 <= 0) {
        this.$message.warning('请输入有效的付款金额')
        return
      }

      this.editDialog.submitting = true

      try {
        const params = {
          id: this.editDialog.editId,
          第几次付款: form.第几次付款,
          付款日期: form.付款日期,
          付款金额: Math.round(form.付款金额 * 100) / 100,
          备注: form.备注 || ''
        }

        console.log('修改参数===', params)

        const res = await sfPlanApi.update(params)
        console.log('修改返回===', res)

        if (res.code === 200) {
          this.$message.success('修改成功')
          this.editDialog.visible = false
          await this.checkPlan()
        } else {
          this.$message.error(res.message || '修改失败')
        }
      } catch (error) {
        console.error('修改失败:', error)
        this.$message.error(error.message || '修改失败，请稍后重试')
      } finally {
        this.editDialog.submitting = false
      }
    },

    // ====== 删除 ======
    async handleDelete(row) {
      if (!this.canModify(row)) {
        this.$message.warning('该记录状态不可删除')
        return
      }

      try {
        await this.$confirm(
          `确认删除第 ${row.第几次付款} 次付款计划吗？删除后不可撤回！`,
          '提示',
          {
            type: 'warning',
            confirmButtonText: '确认删除',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      try {
        const params = { id: row.id }
        console.log('删除参数===', params)

        const res = await sfPlanApi.delete(params)
        console.log('删除返回===', res)

        if (res.code === 200 && res.data?.deleted) {
          this.$message.success('删除成功')
          await this.checkPlan()
        } else {
          this.$message.warning(res.data?.message || '删除失败')
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error.message || '删除失败，请稍后重试')
      }
    },

    // ====== 获取状态标签类型 ======
    getStatusType(status) {
      const map = {
        '待付': 'danger',
        '部分付款': 'warning',
        '已完成': 'success',
        '已中止': 'info',
        '已作废': 'info',
        '其他': 'info',
        '已到期': 'info'
      }
      return map[status] || 'info'
    },

    // ====== 时间戳格式化 ======
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      // 如果是秒级（10位数），转为毫秒级
      if (String(timestamp).length === 10) {
        timestamp = timestamp * 1000
      }
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 时间戳转毫秒（自动识别秒级/毫秒级） ======
    toMilliseconds(timestamp) {
      if (!timestamp) return null
      // 如果是10位数（秒级），转为毫秒级
      if (String(timestamp).length === 10) {
        return timestamp * 1000
      }
      // 如果是13位数（毫秒级），直接返回
      if (String(timestamp).length === 13) {
        return timestamp
      }
      // 其他情况，尝试作为秒级处理
      return timestamp * 1000
    },

    toSeconds(timestamp) {
      if (!timestamp) return null
      // 如果是13位数（毫秒级），转为秒级
      if (String(timestamp).length === 13) {
        return Math.floor(timestamp / 1000)
      }
      return timestamp
    },

    // ====== 加载已保存的付款计划（使用 select 接口） ======
    async loadSavedPlan() {
      if (!this.houseData.id) {
        this.$message.warning('房源ID不存在')
        return
      }

      this.tableLoading = true

      try {
        const params = {
          房源ID: String(this.houseData.id)
        }

        console.log('加载已保存计划参数===', params)

        const res = await sfPlanApi.select(params)
        console.log('加载已保存计划返回===', res)

        if (res.code === 200) {
          const list = res.data?.list || []
          this.savedPlanList = list.map(item => this.mapFields(item))
          
          // 切换到第三部分
          this.showPartThree = true
          this.showPartTwo = false
          this.hasPlan = true

          // 检查是否可以重新生成（所有记录状态必须为"待付"）
          const allPending = this.savedPlanList.every(item => item.状态 === '待付')
          this.canRegenerate = allPending

          console.log('已加载计划数量:', this.savedPlanList.length)
        } else {
          this.$message.error(res.message || '加载数据失败')
        }
      } catch (error) {
        console.error('加载已保存计划失败:', error)
        this.$message.error(error.message || '加载数据失败，请稍后重试')
      } finally {
        this.tableLoading = false
      }
    }
  }
}
</script>

<style scoped>
.plan-dialog /deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

.plan-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.plan-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.plan-dialog-content {
  height: 68vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 8px;
}

.plan-dialog-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.plan-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.plan-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.plan-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.plan-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

/* ====== 第一部分 ====== */
.part-one {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.status-row {
  display: flex;
  align-items: center;
  padding: 8px 0 16px 0;
}

.status-label {
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  margin-right: 12px;
}

.status-tag {
  font-size: 14px;
  padding: 6px 16px;
}

.status-tag i {
  margin-right: 4px;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 8px;
}

/* ====== 第二部分 ====== */
.part-two {
  padding: 0 4px;
}

.temp-table-wrapper {
  margin-bottom: 12px;
}

.temp-save-row {
  display: flex;
  justify-content: flex-end;
  padding: 8px 0;
}

/* ====== 第三部分 ====== */
.part-three {
  padding: 0 4px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 12px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.section-actions {
  display: flex;
  gap: 8px;
}

/* ====== 通用 ====== */
.section-part {
  margin-bottom: 16px;
}

.section-part:last-child {
  margin-bottom: 0;
}

.empty-tip {
  text-align: center;
  padding: 20px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 8px;
}

/* ====== 重新生成确认弹窗（红色主题） ====== */
.regenerate-confirm /deep/ .el-dialog {
  border-top: 4px solid #f56c6c;
}

.regenerate-confirm /deep/ .el-dialog__title {
  color: #f56c6c;
}

/* ====== 响应式 ====== */
@media (max-width: 768px) {
  .plan-dialog /deep/ .el-dialog {
    width: 95% !important;
  }

  .plan-dialog-content {
    height: 50vh;
  }

  .button-row {
    flex-wrap: wrap;
    justify-content: center;
  }

  .status-row {
    flex-wrap: wrap;
  }
}
</style>